import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

// OPTIMIZATION: add this to the store

const useOtherAvatar = (identityIds) => {
  const [avatarUrlsMap, setAvatarUrlsMap] = useState({})

  const getAvatar = (id) => {
    return authedAxios
      .get(`/api/image/avatar/${id}`)
      .then(({ data }) => {
        const url = data
        setAvatarUrlsMap((prev) => ({ ...prev, [id]: url }))
      })
      .catch((e) => {
        setAvatarUrlsMap((prev) => ({ ...prev, [id]: null }))
        // console.error(e)
      })
  }

  useEffect(() => {
    if (identityIds?.length) {
      identityIds.map((id) => {
        if (avatarUrlsMap[id] === undefined) getAvatar(id)
      })
    }
  }, [JSON.stringify(identityIds)])

  return {
    avatarUrlsMap,
  }
}

export default useOtherAvatar
